<template>
  <div class="height-100 text-color-size font-lato">
    <span>不正なアクセスです。</span>
    <div>
      <sp-smart-button class="margin-top-5 error-button" @click="homePage">ホームページ</sp-smart-button>
    </div>
  </div>
</template>

<script>
import SpSmartButton from "@/components/common/sp-smart-button"
import {routeJump} from "@/utils/commonUtils"

export default {
  components: {
    SpSmartButton,
  },
  name: "Forbidden",
  methods: {
    routeJump,
    homePage () {
      // routeJump(this)
      this.$toLogin();
    }
  },
}
</script>

<style scoped>

.text-color-size {
  padding-top: 20%;
  text-align: center;
  font-size: 22px;
  color: #525250;
  background-color: #F2F2ED;
}

</style>
